import { ComputedRef, computed, ref, watch } from '@vue/composition-api';

export function useVideoMuted(videoInfo: ComputedRef<{ [key: string]: any;} | undefined>) {
    const musicBlocked = computed(() => {
        if (videoInfo.value) {
            if (typeof videoInfo.value.musicBlocked === 'boolean') {
                return videoInfo.value.musicBlocked;
            }
        }
        return false;
    });
    const muted = computed(() => musicBlocked.value);
    const canPresetVolume = computed(() => !musicBlocked.value);
    const canChangeVolume = computed(() => !musicBlocked.value);
    return {
        muted,
        canPresetVolume,
        canChangeVolume,
    };
}